/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Landing_TitleInputs */

const en_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You’re Making 
the Earth Greener`)
};

const ar_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت تجعل 
الأرض أكثر خضرة`)
};

const de_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du machst die Erde grüner`)
};

const es_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás haciendo 
la Tierra más verde`)
};

const fr_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous rendez la Terre plus verte`)
};

const it_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stai rendendo
la Terra più verde`)
};

const ja_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地球をより
良い環境に`)
};

const ko_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지구를 더욱
파릇하게 만들어요`)
};

const pt_br_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está tornando
a Terra mais verde`)
};

const ru_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы делаете Землю зеленее`)
};

const th_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณกำลังทำให้
โลกนี้สีเขียวยิ่งขึ้น`)
};

const tr_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünyayı Daha Yeşil Hale Getiriyorsun`)
};

const zh_cn_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是你
让地球多了点树`)
};

const zh_tw_earth_day_2025_landing_title = /** @type {(inputs: Earth_Day_2025_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是你
讓地球多了點樹`)
};

/**
* | output |
* | --- |
* | "You’re Making the Earth Greener" |
*
* @param {Earth_Day_2025_Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_landing_title = /** @type {((inputs?: Earth_Day_2025_Landing_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Landing_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_landing_title(inputs)
	if (locale === "ar") return ar_earth_day_2025_landing_title(inputs)
	if (locale === "de") return de_earth_day_2025_landing_title(inputs)
	if (locale === "es") return es_earth_day_2025_landing_title(inputs)
	if (locale === "fr") return fr_earth_day_2025_landing_title(inputs)
	if (locale === "it") return it_earth_day_2025_landing_title(inputs)
	if (locale === "ja") return ja_earth_day_2025_landing_title(inputs)
	if (locale === "ko") return ko_earth_day_2025_landing_title(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_landing_title(inputs)
	if (locale === "ru") return ru_earth_day_2025_landing_title(inputs)
	if (locale === "th") return th_earth_day_2025_landing_title(inputs)
	if (locale === "tr") return tr_earth_day_2025_landing_title(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_landing_title(inputs)
	return zh_tw_earth_day_2025_landing_title(inputs)
});